"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWhyDidYouUpdate = void 0;
var react_1 = require("react");
function useWhyDidYouUpdate(name, props) {
    var previousProps = (0, react_1.useRef)({});
    (0, react_1.useEffect)(function () {
        if (previousProps.current) {
            var allKeys = Object.keys(__assign(__assign({}, previousProps.current), props));
            var changesObj_1 = {};
            allKeys.forEach(function (key) {
                if (previousProps.current[key] !== props[key]) {
                    // Add to changesObj
                    changesObj_1[key] = {
                        from: previousProps.current[key],
                        to: props[key],
                    };
                }
            });
            if (Object.keys(changesObj_1).length) {
                console.info("[why-did-you-update]", name, changesObj_1);
            }
        }
        previousProps.current = props;
    });
}
exports.useWhyDidYouUpdate = useWhyDidYouUpdate;
